import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { t } from "i18next";
import './Carousel.css'
import { carousel1, carousel2, carousel3, hero1, logo } from "../../../assets/images";
import { useTranslation } from "react-i18next";

const Carousel = () => {

  const { t, i18n } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [showText, setShowText] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const slides = [
    { img: hero1, text: "TANURA ilə Hər Gün Təravətli Dəri", content: "Həkim-kosmetoloq və kosmetoloqlar üçün nəzərdə tutulmuş məhsullar" },
    { img: hero1, text: "TANURA ilə Hər Gün Təravətli Dəri", content: "Həkim-kosmetoloq və kosmetoloqlar üçün nəzərdə tutulmuş məhsullar" },
    { img: hero1, text: "TANURA ilə Hər Gün Təravətli Dəri", content: "Həkim-kosmetoloq və kosmetoloqlar üçün nəzərdə tutulmuş məhsullar" },
  ];

  useEffect(() => {
    const textTimer = setTimeout(() => {
      setShowText(true);
    }, 500);

    const buttonTimer = setTimeout(() => {
      setShowButton(true);
    }, 1500);

    return () => {
      clearTimeout(textTimer);
      clearTimeout(buttonTimer);
    };
  }, [activeIndex]);

  return (
    <div className="max-w-containerSm md:max-w-container mx-auto">
      {/* Header is placed outside the Swiper for it to stay on top */}

      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 10000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        onSlideChange={(swiper) => {
          setShowText(false);
          setShowButton(false);
          setActiveIndex(swiper.activeIndex);
        }}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      > 
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="relative">
              <img src={slide.img} alt={`Slide ${index + 1}`} className="w-full h-[429px] md:h-[673px] object-cover rounded-[16px]" />
              {activeIndex === index && (
                <div className="absolute inset-0 flex flex-col justify-center items-center lg:items-start text-white p-4 lg:px-7 py-5 transition-opacity duration-1000">
                  <div className="md:w-[1320px] relative mx-auto  md:text-center lg:text-left">
                    <div className="h-[40px] md:h-[100px]">  </div>
                    <h2 className={`text-white text-[22px] md:text-5xl font-bold mb-4 md:mt-[116px] lg:mb-5 transition-all duration-1000 transform ${showText ? 'translate-y-0 opacity-100' : '-translate-y-10 opacity-0'}`}>
                      {t(slide.text)}
                    </h2>
                    <h2 className={` text-white text-[16px] md:text-xl font-normal mb-4 lg:mb-7 transition-all duration-1000 transform ${showText ? 'translate-y-0 opacity-100' : '-translate-y-10 opacity-0'}`}>
                      {t(slide.content)}
                    </h2>

                    <div className="">
                      <a href="/about">
                        <button className={`w-[146px] h-10 bg-[#223077] hover:bg-[#898989] rounded-lg transition-all duration-1000 transform ${showButton ? 'translate-y-0 opacity-100' : '-translate-y-10 opacity-0'}`}>
                          {t("İndi al")}
                        </button>
                      </a>
                    </div>
              
                <div className="flex justify-end w-[95%]">
                <div className="flex md:w-[414px] md:h-[146px] bg-[#A0B0B5] p-4 rounded-[36px] gap-5 mt-[70px]">
   <div className="md:w-[114px] w-[64px]"> <img src={carousel1}></img> </div>
   <div className="md:w-[114px] w-[64px]"> <img src={carousel2}></img> </div>
   <div className="md:w-[114px] w-[64px]"> <img src={carousel3}></img> </div>

                  </div>
                  </div>
                  </div>
                </div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Carousel;
